import { settings } from '../config';
import { getToken } from './../global/TokenValidator';
import { Team } from '../types/maintenanceTeams';

class MaintenanceTeams {
    GetTeams = async (): Promise<{ message: string, status:boolean, teams: Team[] }> => {
        return fetch(`${settings.HOST}/TeamLead/GetTeams`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    GetTeamsByEmployee = async (employeeId: number): Promise<{ message: string, status:boolean, teams: Team[] }> => {
        return fetch(`${settings.HOST}/TeamLead/GetTeamsByEmployee/${employeeId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    CreateTeam = async (teamName: string, teamLeaderId: number): Promise<{ message: string, status:boolean, team: Team }> => {
        return fetch(`${settings.HOST}/TeamLead/CreateTeam`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                TeamName: teamName,
                TeamLeaderId: teamLeaderId,
            }),
        }).then(x => {
            return x.json()
        })
    }
    EditTeam = async (teamId: number, teamName: string, teamLeaderId: number): Promise<{ message: string, status:boolean, team: Team }> => {
        return fetch(`${settings.HOST}/TeamLead/EditTeam`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                Id: teamId,
                TeamName: teamName,
                TeamLeaderId: teamLeaderId,
            }),
        }).then(x => {
            return x.json()
        })
    }
    DeleteTeam = async (teamId: number): Promise<{ message: string, status:boolean }> => {
        return fetch(`${settings.HOST}/TeamLead/DeleteTeam/${teamId}`, {
            method: 'DELETE',   
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            }
        }).then(x => {
            return x.json()
        })  
    }
    AddTeamMember = async (teamId: number, memberId: number): Promise<{ message: string, status:boolean, team: Team }> => {
        return fetch(`${settings.HOST}/TeamLead/AddTeamMember`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                TeamId: teamId,
                TeamMemberId: memberId,
            }),
        }).then(x => {
            return x.json()
        })
    }
    RemoveTeamMember = async (teamId: number, memberId: number): Promise<{ message: string, status:boolean, team: Team }> => {
        return fetch(`${settings.HOST}/TeamLead/DeleteTeamMember`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                TeamId: teamId,
                TeamMemberId: memberId,
            }),
        }).then(x => {
            return x.json()
        })  
    }
}
const MaintenanceTeamsApi = new MaintenanceTeams();
export default MaintenanceTeamsApi;